import { render, staticRenderFns } from "./FeedbackInboxTab.vue?vue&type=template&id=7e7e2d6a&scoped=true&"
import script from "./FeedbackInboxTab.vue?vue&type=script&lang=js&"
export * from "./FeedbackInboxTab.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackInboxTab.vue?vue&type=style&index=0&id=7e7e2d6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7e2d6a",
  null
  
)

export default component.exports